const OBJECT_URL_REVOKE_DELAY_MS = 10_000;

export const scheduleObjectUrlRevocation = (objectUrl: string) => {
  // Anchor-triggered downloads do not expose a completion signal, so keep the
  // blob URL alive briefly to avoid revoking it before the browser starts the download.
  window.setTimeout(() => {
    URL.revokeObjectURL(objectUrl);
  }, OBJECT_URL_REVOKE_DELAY_MS);
};
